var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { DashboardClientService } from '../../../../services/dashboard/dashboard-client.service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
var EditDashboardsMetadataDialog = /** @class */ (function () {
    function EditDashboardsMetadataDialog(dialogClient, dashboardClientService) {
        var _this = this;
        this.dialogClient = dialogClient;
        this.dashboardClientService = dashboardClientService;
        this.dashboardClientService.getDashbardsForUser().then(function (response) {
            _this.dashboards = response.dashboards;
        });
    }
    EditDashboardsMetadataDialog.prototype.remove = function (item) {
        this.dashboards.splice(this.dashboards.indexOf(item), 1);
    };
    EditDashboardsMetadataDialog.prototype.saveDashboards = function () {
        var _this = this;
        this.dashboardClientService.persistDashboards(this.dashboards).then(function (resp) {
            _this.dashboardViewModel.loadUserDashboards();
            _this.dialogClient.hide();
        });
    };
    EditDashboardsMetadataDialog.prototype.cancel = function () {
        this.dialogClient.hide();
    };
    EditDashboardsMetadataDialog.prototype.activate = function (viewModel) {
        this.dashboardViewModel = viewModel;
    };
    EditDashboardsMetadataDialog = __decorate([
        transient(),
        autoinject(),
        __metadata("design:paramtypes", [DialogClientService, DashboardClientService])
    ], EditDashboardsMetadataDialog);
    return EditDashboardsMetadataDialog;
}());
export { EditDashboardsMetadataDialog };
